// src/stores/unreadMessagesStore.js
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { doc, onSnapshot } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '@/firebase';

export const useUnreadMessagesStore = defineStore('unreadMessages', () => {
  const unreadCount = ref(0);
  const isLoading = ref(false);
  const error = ref(null);

  let unreadMessagesUnsubscribe = null;
  let authUnsubscribe = null;

  // Dinleyiciyi başlat
  function startListening() {
    const auth = getAuth();

    // Önce varsa dinleyicileri temizle
    stopListening();

    isLoading.value = true;

    // Auth durumunu dinle
    authUnsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        if (user) {
          setupUserListener(user.uid);
        } else {
          unreadCount.value = 0;
          if (unreadMessagesUnsubscribe) {
            unreadMessagesUnsubscribe();
            unreadMessagesUnsubscribe = null;
          }
        }
        isLoading.value = false;
      },
      (err) => {
        error.value = err.message;
        isLoading.value = false;
      },
    );
  }

  // Kullanıcı dinleyicisini kur
  function setupUserListener(userId) {
    if (unreadMessagesUnsubscribe) {
      unreadMessagesUnsubscribe();
    }

    const unreadRef = doc(db, 'unread_messages', userId);
    unreadMessagesUnsubscribe = onSnapshot(
      unreadRef,
      (doc) => {
        if (doc.exists()) {
          const unreadMessageIds = doc.data().unreadMessageId || [];
          unreadCount.value = unreadMessageIds.length;
        } else {
          unreadCount.value = 0;
        }
      },
      (err) => {
        error.value = err.message;
        console.error('Unread messages dinleme hatası:', err);
      },
    );
  }

  // Dinleyicileri durdur
  function stopListening() {
    if (unreadMessagesUnsubscribe) {
      unreadMessagesUnsubscribe();
      unreadMessagesUnsubscribe = null;
    }

    if (authUnsubscribe) {
      authUnsubscribe();
      authUnsubscribe = null;
    }
  }

  // Mesaj verilerini manuel güncelleme (gerekirse)
  function setUnreadCount(count) {
    unreadCount.value = count;
  }

  // Hata durumunu temizle
  function clearError() {
    error.value = null;
  }

  return {
    unreadCount,
    isLoading,
    error,
    startListening,
    stopListening,
    setUnreadCount,
    clearError,
  };
});
